import { render, staticRenderFns } from "./mobileBottomFooter.vue?vue&type=template&id=c9c91aba&scoped=true&"
import script from "./mobileBottomFooter.vue?vue&type=script&lang=js&"
export * from "./mobileBottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./mobileBottomFooter.vue?vue&type=style&index=0&id=c9c91aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c91aba",
  null
  
)

export default component.exports